import api from "@/api/api";

export async function fetchRawMaterialData(mfId) {
  const res = await api.get(`/rawMaterial/list?mfId=${mfId}`);
  return res.data.result.rawMaterialList || [];
}

export async function fetchBizLocationData(mfId) {
  const res = await api.get(`/bizLocation/list?mfId=${mfId}`);
  return res.data.result.bizLocationList || [];
}

export async function fetchReadPointData(mfId, withImage = 'N') {
  const res = await api.get(`/readPoint/list?mfId=${mfId}&withImage=${withImage}`);
  return res.data.result.readPointList || [];
}

export async function fetchProductData(mfId) {
  const res = await api.get(`/product/list?mfId=${mfId}`);
  return res.data.result.productList || [];
}

export async function fetchBoxData(mfId) {
  const res = await api.get(`/rawMaterial/list?type=07&mfId=${mfId}`);
  return res.data.result.rawMaterialList || [];
}

export async function fetchVehicleData(mfId) {
  const res = await api.get(`/vehicle/list?mfId=${mfId}`);
  return res.data.result.vehicleList || [];
}


